import { Menu, MenuItem } from '@pepper/ui'
import clsx from 'clsx'
import { FC } from 'react'
import {
  BooleanParam,
  NumberParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import s from './Items.module.css'

type Props = {
  onChange: () => void
}

export const Items: FC<Props> = ({ onChange }) => {
  const [query, setQuery] = useQueryParams({
    item_id: withDefault(BooleanParam, undefined),
    page: withDefault(NumberParam, 1),
  })

  const handleSubmit = (existsItemId: boolean) => {
    setQuery({ item_id: existsItemId, page: 1 })
    onChange()
  }

  return (
    <Menu className={s.menu}>
      <MenuItem
        onClick={() => handleSubmit(true)}
        className={clsx(s.menuItem, {
          [s.active]: query.item_id,
        })}
      >
        With item
      </MenuItem>
      <MenuItem
        onClick={() => handleSubmit(false)}
        className={clsx(s.menuItem, {
          [s.active]: query.item_id === false,
        })}
      >
        Without item
      </MenuItem>
    </Menu>
  )
}
